export default {
  getPredictLocations: state => state.predictLocations,
  getCurrentInput: state => state.currentInput,
}
